import UiListItem from "./UiListItem";
import MiezzListItem from "@/models/MiezzListItem";
import { EnumPipe } from "@/models/EnumPipe";
import DtoListItemPackageZh_PackageEn from "./DtoListItemPackageZh_PackageEn";
import { EnumParamAuditStatus, EnumParamAuditStatusOption } from "./EnumParamAuditStatus";

/**
 * 中文包装种类分页列表-项
 * @description 自动生成的代码,请勿修改
 */
export default class DtoListItemPackageZh extends UiListItem<string> {
    constructor() {
        //无参构造函数
        super()
        this.Status = EnumParamAuditStatus.Not;
        this.IsEdit = false;
    }

    [proName: string]: any;
    /**
     * 包装类型（中）
     */
    Name?: string;
    /**
     * 包装类型（英）
     */
    PackageEn?: DtoListItemPackageZh_PackageEn;
    /**
     * 中国海关代码
     */
    Code?: string;
    /**
     * 审核状态
     */
    Status?: EnumParamAuditStatus;
    /**
     * 是否可以编辑
     */
    IsEdit?: boolean;
    /**
     * 创建人所属公司
     */
    CreatedCompanyId?: string;
}

/**
 * 中文包装种类分页列表-项-表单校验
 */
export const DtoListItemPackageZhRules = {
}

/**
 * 中文包装种类分页列表-项-设置项
 */
export const DtoListItemPackageZhMiezzListItems: MiezzListItem[]  = [
  {
    Prop: "Name",
    Label: "包装类型（中）",
  },
  {
    Prop: "PackageEn",
    Label: "包装类型（英）",
    Customize: true,
  },
  {
    Prop: "Code",
    Label: "中国海关代码",
  },
]
